import { Reveal } from "./anim";

const ARTIST_IMG =
  "https://images.unsplash.com/flagged/photo-1555604858-34f65cfdc1db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxtdXNpYyUyMHN0dWRpbyUyMHByb2R1Y2VyJTIwZGFyayUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTQ3MjI1Mnww&ixlib=rb-4.1.0&q=85";

const QUOTES = [
  { q: "My EP hit every platform in under two days. The review team actually caught a metadata slip that would've cost me playlists.", name: "Mara Vell", role: "Independent artist" },
  { q: "Running a small label used to mean spreadsheets and chaos. Noizbloc gives me splits, analytics and delivery in one place.", name: "Dorian Keys", role: "Founder, Nightshift Records" },
  { q: "Zero commission and I can see exactly where my listeners are. It changed how I plan tours.", name: "Ivo Sol", role: "Producer" },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 sm:py-32 bg-[#040a1a] border-y border-white/5" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative rounded-3xl overflow-hidden border border-white/10 aspect-[4/5]">
                <img src={ARTIST_IMG} alt="Featured artist" className="w-full h-full object-cover grayscale opacity-85" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#020617]/70 to-transparent" />
                <div className="absolute bottom-6 left-6">
                  <div className="text-white font-display text-xl">Trusted by the underground</div>
                  <div className="text-slate-400 text-sm mt-1">2,400+ artists & labels</div>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 space-y-10">
            <Reveal>
              <span className="text-xs tracking-[0.25em] uppercase font-bold text-slate-400">Voices</span>
            </Reveal>
            {QUOTES.map((t, i) => (
              <Reveal key={t.name} delay={i * 0.06}>
                <figure className="border-l-2 border-blue-500/60 pl-6">
                  <blockquote className="font-display text-xl sm:text-2xl md:text-[1.7rem] leading-snug tracking-tight text-white">
                    “{t.q}”
                  </blockquote>
                  <figcaption className="mt-4 text-sm text-slate-400">
                    <span className="text-white font-medium">{t.name}</span> — {t.role}
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
